// extracted by mini-css-extract-plugin
export var formContainer = "_id-0";
export var message = "_id-1";